export default "__VITE_ASSET__BgdqzeHd__"